<div class="result-icon" [ngClass]="resultClass" *ngIf="showResultType">
  <app-icon iconName="circle"></app-icon>
</div>
